import { render, staticRenderFns } from "./treeSelector.vue?vue&type=template&id=355fca2e&"
import script from "./treeSelector.vue?vue&type=script&lang=js&"
export * from "./treeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/tree/treeSelector.vue"
export default component.exports